export default __webpack_public_path__ + "static/media/category_ce.f360fa38.svg";